<app-groups-renderer
  [groups]="groups()"
  [loadingGroups]="loadingGroups()"
  [isLoading]="isLoading()"
  (componentAction)="onAction($event)"
/>
